<div class="flex flex-col p-6 gap-5">
  <ep-breadcrumbs>
    <ep-breadcrumb [routerLink]="['/']"><span>Realm</span></ep-breadcrumb>
    <ep-breadcrumb><span>Client Requests</span></ep-breadcrumb>
  </ep-breadcrumbs>

  <div class="flex items-center justify-between">
    <h1>Client Requests</h1>
  </div>

  @if (isLoading() || loadError()) {
    <app-load-status [error]="loadError()" loadingLabel="Loading client requests" />
  } @else {
    <section class="flex flex-col gap-3">
      <h2 class="heading-md">Pending ({{ pendingRequests().length }})</h2>

      @if (pendingRequests().length === 0) {
        <p class="body-sm text-fg-subtle">No pending requests.</p>
      } @else {
        @for (request of pendingRequests(); track request.id) {
          <app-client-request-card [request]="request" [showRequester]="true" [adminView]="true">
            <ep-textfield
              label="Client ID"
              [value]="getEditedClientId(request)"
              (input)="setEditedClientId(request, $any($event.target).value)"
            ></ep-textfield>

            @if (isDenyMode(request)) {
              <ep-textfield
                label="Reason for denial"
                [value]="getDenyReason(request)"
                (input)="setDenyReason(request, $any($event.target).value)"
              ></ep-textfield>
            }

            @if (getActionError(request)) {
              <ep-alert type="alert" color="danger" variant="alt">
                <span slot="header">{{ getActionError(request) }}</span>
              </ep-alert>
            }

            <div slot="actions" class="flex justify-end gap-2 w-full">
              @if (isDenyMode(request)) {
                <ep-button variant="quiet" size="small" (click)="toggleDenyMode(request)">
                  Cancel
                </ep-button>
                <ep-button
                  color="danger"
                  size="small"
                  [disabled]="isActionDisabled(request)"
                  (click)="deny(request)"
                >
                  Confirm Deny
                </ep-button>
              } @else {
                <ep-button
                  color="danger"
                  variant="outline"
                  size="small"
                  [disabled]="isActionDisabled(request)"
                  (click)="toggleDenyMode(request)"
                >
                  Deny
                </ep-button>
                <ep-button
                  color="primary"
                  size="small"
                  [disabled]="isActionDisabled(request)"
                  (click)="approve(request)"
                >
                  Approve
                </ep-button>
              }
            </div>
          </app-client-request-card>
        }
      }
    </section>

    <section class="flex flex-col gap-3">
      <h2 class="heading-md">Resolved ({{ resolvedRequests().length }})</h2>

      @if (resolvedRequests().length === 0) {
        <p class="body-sm text-fg-subtle">No resolved requests yet.</p>
      } @else {
        @for (request of resolvedRequests(); track request.id) {
          <app-client-request-card [request]="request" [showRequester]="true" [adminView]="true" />
        }
      }
    </section>
  }
</div>
